<script>
export default {
  data: function () {
    return {}
  },
  methods: {
    formatDate: function (dateTime) {
      var results = ''

      if (dateTime) {
        let match = dateTime.match(/^(.+)T.*$/)

        if (match) {
          results = match[1].replace(/-/g, '/')
        }
      }

      return results
    },
    whileCurrentYear: function () {
      let currentYear = (new Date()).getFullYear()
      return currentYear - 1929
    }
  }
}
</script>
